export default "__VITE_ASSET__CmZ4w9d9__"